module.exports = __webpack_public_path__ + "static/media/raindrops.08735759.svg";